module.exports = __webpack_public_path__ + "292606565d575c8447f934f8aba3c4fb.png";